import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Box)(({ theme }) => ({
  "& .rct-node.GROUP .rct-title": {
    fontWeight: 500,
    color: theme.palette.secondary.main,
  },
  "& .rct-node.LAYER .rct-title": {
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  "& label": {
    display: "inline-flex",
    alignItems: "center",
  },
  "& .rct-node-leaf label": {
    display: "flex",
    width: "100%",
  },
  "& .rct-node-leaf .rct-title": {
    flex: 1,
    minWidth: 0,
  },
}));
